<ng-container [ngSwitch]="status">
    <label *ngSwitchCase="BLUECHAT_DELIVERY_STATUS.PICK_PENDING" class="status bg large status-pick-pending">
        <span [i18n]="'bluechat.delivery-status.pick-pending'"></span>
    </label>
    <label *ngSwitchCase="BLUECHAT_DELIVERY_STATUS.PICKING_UP" class="status bg large status-picking-up">
        <span [i18n]="'bluechat.delivery-status.picking-up'"></span>
    </label>
    <label *ngSwitchCase="BLUECHAT_DELIVERY_STATUS.PICKED" class="status bg large status-picked">
        <span [i18n]="'bluechat.delivery-status.picked'"></span>
    </label>
    <label *ngSwitchCase="BLUECHAT_DELIVERY_STATUS.DROPPING" class="status bg large status-dropping">
        <span [i18n]="'bluechat.delivery-status.dropping'"></span>
    </label>
    <label *ngSwitchCase="BLUECHAT_DELIVERY_STATUS.DELIVERED" class="status bg large status-delivered">
        <span [i18n]="'bluechat.delivery-status.delivered'"></span>
    </label>
    <label *ngSwitchCase="BLUECHAT_DELIVERY_STATUS.CLOSED" class="status bg large status-closed">
        <span [i18n]="'bluechat.delivery-status.closed'"></span>
    </label>
    <label *ngSwitchCase="BLUECHAT_DELIVERY_STATUS.CANCELLED" class="status bg large status-closed">
        <span [i18n]="'bluechat.delivery-status.cancelled'"></span>
    </label>
</ng-container>

<label (click)="openEtaDetailList()" *ngIf="displayEta" class="eta-status status bg large" [ngClass]="'eta-type-'+etaType">
    <label *ngIf="eta != null" class="timezone-offset">
        <span>{{ timezoneOffset }}</span>
    </label>
    <span [i18n]="'bluechat.search.delivery.eta'"></span>
    <small>{{(eta | date: 'yyyy-MM-dd HH:mm') || '-'}}</small>
    <div class="eta-type">
        <app-delivery-eta-type-icon [etaType]="etaType"></app-delivery-eta-type-icon>
    </div>
</label>
